import { z } from 'zod';

export const AddMessageSchema = z.object({
    name_en: z.string().min(1, 'name_en is required.'),
    name_ar: z.string().min(1, 'name_ar is required'),
    disc_en: z.string().min(1, 'disc_en field is required.'),
    disc_ar: z.string().min(1, 'disc_ar is required'),
    notes: z.string().min(1, 'notes is required'),
    price: z.string().optional().default(''),
});

export type AddMessageFormValues = z.infer<typeof AddMessageSchema>;
